<template>
  <footer class="col-start-1 col-end-13 row-start-7 row-end-8 bg-indigo-300">
    <div class="container mx-auto xxl:px-6 py-10">
      <div class="text-white text-sm md:text-base leading-6 text-center">
        <p class="my-1 font-bold tracking-wider text-center">+372 55 00 184 | webline.offer@gmail.com</p>
        <p class="my-1">Ujula 2a, Tartu linn </p>
        <p class="my-1"
        >&copy; 2020 Webline. Kõik õigused kaitstud.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter",
};
</script>

<style scoped>
</style>
